import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Analyzer, Snapshot } from 'types';

const removeCrosspolSnapshots = (snapshots: Snapshot[]) => {
  const crosspolSnapshotIds = snapshots?.map(
    (snapshot) => snapshot?.crosspol_snapshot_id
  );
  const filteredSnapshots = snapshots?.filter(
    (snapshot) => !crosspolSnapshotIds.includes(snapshot.id)
  );
  return filteredSnapshots || [];
};

export const getAllSnapshotsWithoutCrosspol = async (): Promise<Snapshot[]> => {
  const { data }: { data: Analyzer[] } = await axios.get(`/api/analyzers`, {
    params: {
      includeSnapshots: true,
    },
  });

  const snapshots = data.flatMap((analyzer) => {
    const snapshotsToReturn = analyzer.snapshots;
    for (const snapshot of snapshotsToReturn) {
      snapshot.analyzer = analyzer;
    }
    return analyzer.snapshots;
  });
  return snapshots as Snapshot[];
};

type QueryFnType = typeof getAllSnapshotsWithoutCrosspol;

type UseSnapshotsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAllSnapshotsWithoutCrosspol = ({
  config,
}: UseSnapshotsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['snapshots', 'list'],
    queryFn: () => getAllSnapshotsWithoutCrosspol(),
    select: (data) => removeCrosspolSnapshots(data),
    ...config,
  });
};
